(function () {
  var buybar = document.querySelector("[data-buybar]");
  var hero = document.querySelector(".hero");
  if (buybar && hero && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) {
      buybar.classList.toggle("show", !e[0].isIntersecting);
    }, { rootMargin: "-40px 0px 0px 0px" }).observe(hero);
  }
  var form = document.querySelector(".capture-form");
  if (form) form.addEventListener("submit", function (ev) {
    ev.preventDefault();
    var path = (form.elements.path && form.elements.path.value) || "Supermind";
    var note = form.querySelector("[data-form-result]");
    if (note) note.textContent = "Request received for " + path + ". We'll be in touch.";
    form.reset();
  });
})();
